// Node Modules
import { nanoid } from 'nanoid';

// Components
import Photo from './Photo';
import Button from '@/components/global-components/Button';
import Modal, { useModal } from '@/components/global-components/modal/Modal';
import PhotoCarousel from './PhotoCarousel';

const DesktopPhotoContainer = ({
  images,
  buttonTexts,
  isDesktop, 
}) => {
  const srcs = images.slice(1, 5);
  const {
    isShowing,
    toggle, 
  } = useModal();

  return (
    <>
      <div className='container'>
        <div className='photo-container'>
          <div>
            <Photo src={images[0].image} />
          </div>
          <div className='photos'>
            {srcs.map(src => (
              <div key={nanoid()} className='photo'>
                <Photo src={src.image} />
              </div>
            ))}
          </div>
        </div>
        <Button
          className='tertiary photos'
          text={buttonTexts}
          onClick={toggle}
        />
      </div>
      <Modal isShowing={isShowing} hide={toggle} isCloseOnClickOutside={true}>
        <PhotoCarousel
          images={images}
          showButtons={true}
          isDesktop={isDesktop}
        />
      </Modal>
      <style jsx>{`
        div.container div.photo-container {
          display: flex;
        }

        div.container {
          position: relative;
        }

        div.photo-container > :first-child {
          padding-right: 0.75em;
        }

        div.photo-container > *:not(:first-child) {
          padding-left: 0.75em;
        }

        div.photo-container div {
          width: 100%;
          gap: inherit;
          height: 516px;
        }

        div.photos {
          display: flex;
          flex-wrap: wrap;
        }

        div.photos div.photo {
          width: 50%;
          height: 50%;
        }

        div.photos div.photo:nth-child(-n + 2) {
          padding-bottom: 0.75em;
        }

        div.photos div.photo:nth-last-child(-n + 2) {
          padding-top: 0.75em;
        }

        div.photos div.photo:nth-child(2n + 1) {
          padding-right: 0.75em;
        }

        div.photos div.photo:nth-child(2n + 0) {
          padding-left: 0.75em;
        }
      `}</style>
      <style global jsx>{`
        div.container a.photos {
          width: 158px;
          position: absolute;
          bottom: 1em;
          right: 1em;
        }
      `}</style>
    </>
  );
};

export default DesktopPhotoContainer;
